import { createSelector } from 'reselect'

import { selectLandingOfferings } from 'partner360/features/landing'
import { getCount } from 'partner360/features/landing/helpers/getCount'
import { LandingOffering } from 'partner360/models/landing/LandingOffering'
import { LandingStatus } from 'partner360/models/landing/LandingStatus'

import { selectLandingState } from './selectLandingState'

export const selectPartnersCountInOfferings = createSelector(
  [selectLandingState, selectLandingOfferings],
  ({ processedPlannings, selectedPlanning, selectedStatus, selectedCategory }, offerings) => {
    return offerings
      .map((el) => el.Offering)
      .map((offering) => {
        if (offering === LandingOffering.Total) {
          const filtered = processedPlannings.filter(
            (el) =>
              el.planningId === selectedPlanning.PlanningId &&
              el.category === selectedCategory &&
              el.status === selectedStatus
          )

          return {
            offering,
            allCounts: getCount(filtered),
            completedCount: getCount(
              filtered.filter((el) => el.status === LandingStatus.Acknowledged)
            ),
          }
        }
        const filtered = processedPlannings.filter(
          (el) =>
            el.planningId === selectedPlanning.PlanningId &&
            el.offering === offering &&
            el.category === selectedCategory &&
            el.status === selectedStatus
        )

        return {
          offering,
          allCounts: getCount(filtered),
          completedCount: getCount(
            filtered.filter((el) => el.status === LandingStatus.Acknowledged)
          ),
        }
      })
  }
)
